import Toast from '../../component/toastify/Index.jsx';
import axios from '../../axios/interceptor.js';

export const getCustomerStammdaten = async (payload, clientId) => {
    try {
        const response = await axios.post(`/admin/stammdaten/getStammdaten/${clientId}`, payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const updateCustomerStammdaten = async (payload, clientId) => {
    try {
        const response = await axios.put(`/admin/stammdaten/updateStammdaten/${clientId}`, payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}


// document upload APIs

export const addStammdatenDocument = async (payload, clientId) => {
    try {
        const response = await axios.post(`/admin/stammdaten/addStammdatenDocument/${clientId}`, payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}


export const updateStammdatenDocument = async (id, payload, clientId) => {
    try {
        const response = await axios.put(`/admin/stammdaten/updateStammdatenDocument/${id}/${clientId}`, payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const deleteStammdatenDocument = async (id, clientId) => {
    try {
        const response = await axios.put(`/admin/stammdaten/deleteStammdatenDocument/${id}/${clientId}`)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const getSelectCustomerCompanyDetails = async (clientId) => {
    try {
        const response = await axios.get(`/admin/stammdaten/getCustomerCompany/${clientId}`)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}